// src/components/RichText/RichTextPreview.js
import DOMPurify from 'dompurify';
import { convertFromRaw } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './RichText.css'

const RichTextPreview = (props) => {
	const { rawContent } = props

	const createMarkup = (raw) => {
		const options = {
			inlineStyles: {
				// Override default element (`strong`).
				SUPERSCRIPT: {element: 'sup'},
				SUBSCRIPT: {element: 'sub'},
			},
		}
		// raw puede ser: objeto Draft.js, string JSON, o HTML legacy de v1
		let html
		if (typeof raw === 'string') {
			const trimmed = raw.trim()
			if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
				try {
					html = stateToHTML(convertFromRaw(JSON.parse(trimmed)), options)
				} catch (e) {
					html = trimmed // ya es HTML
				}
			} else {
				html = trimmed // HTML legacy
			}
		} else {
			html = stateToHTML(convertFromRaw(raw), options)
		}
		return {
			__html: DOMPurify.sanitize(html)
		}
	}

	return (
		rawContent && <div className="rich-text-preview" dangerouslySetInnerHTML={createMarkup(rawContent)}></div>
	)
}

export default RichTextPreview